export enum Currency {
  IcelandicKrona = 'ISK',
  UnitedStatesDollar = 'USD',
  Euro = 'EUR',
  CanadianDollar = 'CAD'
}
